// action - state management
import { LOGIN, LOGOUT, REGISTER, UNAUTHORIZED } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    noAccessRight: false,
    user: null,
    scope: []
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                noAccessRight: false,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                noAccessRight: false,
                user: null
            };
        }
        case UNAUTHORIZED: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                noAccessRight: true,
                user: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
